export enum ISICSection {
  A_SECTION = 'A_SECTION',
  B_SECTION = 'B_SECTION',
  C_SECTION = 'C_SECTION',
  D_SECTION = 'D_SECTION',
  E_SECTION = 'E_SECTION',
  F_SECTION = 'F_SECTION',
  G_SECTION = 'G_SECTION',
  H_SECTION = 'H_SECTION',
  I_SECTION = 'I_SECTION',
  J_SECTION = 'J_SECTION',
  K_SECTION = 'K_SECTION',
  L_SECTION = 'L_SECTION',
  M_SECTION = 'M_SECTION',
  N_SECTION = 'N_SECTION',
  O_SECTION = 'O_SECTION',
  P_SECTION = 'P_SECTION',
  Q_SECTION = 'Q_SECTION',
  R_SECTION = 'R_SECTION',
  S_SECTION = 'S_SECTION',
  T_SECTION = 'T_SECTION',
  U_SECTION = 'U_SECTION',
  Z_SECTION = 'Z_SECTION',
}

export enum ISICDivision {
  // A_SECTION
  A_01 = 'A_01',
  A_02 = 'A_02',
  A_03 = 'A_03',
  // B_SECTION
  B_05 = 'B_05',
  B_06 = 'B_06',
  B_07 = 'B_07',
  B_08 = 'B_08',
  B_09 = 'B_09',
  // C_SECTION
  C_10 = 'C_10',
  C_11 = 'C_11',
  C_12 = 'C_12',
  C_13 = 'C_13',
  C_14 = 'C_14',
  C_15 = 'C_15',
  C_16 = 'C_16',
  C_17 = 'C_17',
  C_18 = 'C_18',
  C_19 = 'C_19',
  C_20 = 'C_20',
  C_21 = 'C_21',
  C_22 = 'C_22',
  C_23 = 'C_23',
  C_24 = 'C_24',
  C_25 = 'C_25',
  C_26 = 'C_26',
  C_27 = 'C_27',
  C_28 = 'C_28',
  C_29 = 'C_29',
  C_30 = 'C_30',
  C_31 = 'C_31',
  C_32 = 'C_32',
  C_33 = 'C_33',
  // D_SECTION
  D_35 = 'D_35',
  // E_SECTION
  E_36 = 'E_36',
  E_37 = 'E_37',
  E_38 = 'E_38',
  E_39 = 'E_39',
  // F_SECTION
  F_41 = 'F_41',
  F_42 = 'F_42',
  F_43 = 'F_43',
  // G_SECTION
  G_45 = 'G_45',
  G_46 = 'G_46',
  G_47 = 'G_47',
  // H_SECTION
  H_49 = 'H_49',
  H_50 = 'H_50',
  H_51 = 'H_51',
  H_52 = 'H_52',
  H_53 = 'H_53',
  // I_SECTION
  I_55 = 'I_55',
  I_56 = 'I_56',
  // J_SECTION
  J_58 = 'J_58',
  J_59 = 'J_59',
  J_60 = 'J_60',
  J_61 = 'J_61',
  J_62 = 'J_62',
  J_63 = 'J_63',
  // K_SECTION
  K_64 = 'K_64',
  K_65 = 'K_65',
  K_66 = 'K_66',
  // L_SECTION
  L_68 = 'L_68',
  // M_SECTION
  M_69 = 'M_69',
  M_70 = 'M_70',
  M_71 = 'M_71',
  M_72 = 'M_72',
  M_73 = 'M_73',
  M_74 = 'M_74',
  M_75 = 'M_75',
  // N_SECTION
  N_77 = 'N_77',
  N_78 = 'N_78',
  N_79 = 'N_79',
  N_80 = 'N_80',
  N_81 = 'N_81',
  N_82 = 'N_82',
  // O_SECTION
  O_84 = 'O_84',
  // P_SECTION
  P_85 = 'P_85',
  // Q_SECTION
  Q_86 = 'Q_86',
  Q_87 = 'Q_87',
  Q_88 = 'Q_88',
  // R_SECTION
  R_90 = 'R_90',
  R_91 = 'R_91',
  R_92 = 'R_92',
  R_93 = 'R_93',
  // S_SECTION
  S_94 = 'S_94',
  S_95 = 'S_95',
  S_96 = 'S_96',
  // T_SECTION
  T_97 = 'T_97',
  T_98 = 'T_98',
  // U_SECTION
  U_99 = 'U_99',
  // Z_SECTION
  Z_99 = 'Z_99',
  Z_100 = 'Z_100',
  Z_101 = 'Z_101',
  Z_102 = 'Z_102',
  Z_103 = 'Z_103',
  Z_104 = 'Z_104',
}

export enum ISICClass {
  A_011 = 'A_011',
  A_0111 = 'A_0111',
  A_0112 = 'A_0112',
  A_0113 = 'A_0113',
  A_0114 = 'A_0114',
  A_0115 = 'A_0115',
  A_0116 = 'A_0116',
  A_0119 = 'A_0119',
  A_012 = 'A_012',
  A_0121 = 'A_0121',
  A_0122 = 'A_0122',
  A_0123 = 'A_0123',
  A_0124 = 'A_0124',
  A_0125 = 'A_0125',
  A_0126 = 'A_0126',
  A_0127 = 'A_0127',
  A_0128 = 'A_0128',
  A_0129 = 'A_0129',
  A_0130 = 'A_0130',
  A_014 = 'A_014',
  A_0141 = 'A_0141',
  A_0142 = 'A_0142',
  A_0143 = 'A_0143',
  A_0144 = 'A_0144',
  A_0145 = 'A_0145',
  A_0146 = 'A_0146',
  A_0149 = 'A_0149',
  A_0150 = 'A_0150',
  A_016 = 'A_016',
  A_0161 = 'A_0161',
  A_0162 = 'A_0162',
  A_0163 = 'A_0163',
  A_0164 = 'A_0164',
  A_0170 = 'A_0170',

  A_0210 = 'A_0210',
  A_0220 = 'A_0220',
  A_0230 = 'A_0230',
  A_0240 = 'A_0240',

  A_031 = 'A_031',
  A_0311 = 'A_0311',
  A_0312 = 'A_0312',
  A_032 = 'A_032',
  A_0321 = 'A_0321',
  A_0322 = 'A_0322',

  B_0510 = 'B_0510',
  B_0520 = 'B_0520',

  B_0610 = 'B_0610',
  B_0620 = 'B_0620',

  B_0710 = 'B_0710',
  B_072 = 'B_072',
  B_0721 = 'B_0721',
  B_0729 = 'B_0729',

  B_0810 = 'B_0810',
  B_089 = 'B_089',
  B_0891 = 'B_0891',
  B_0892 = 'B_0892',
  B_0893 = 'B_0893',
  B_0899 = 'B_0899',

  B_0910 = 'B_0910',
  B_0990 = 'B_0990',

  C_1010 = 'C_1010',
  C_1020 = 'C_1020',
  C_1030 = 'C_1030',
  C_1040 = 'C_1040',
  C_1050 = 'C_1050',
  C_106 = 'C_106',
  C_1061 = 'C_1061',
  C_1062 = 'C_1062',
  C_107 = 'C_107',
  C_1071 = 'C_1071',
  C_1072 = 'C_1072',
  C_1073 = 'C_1073',
  C_1074 = 'C_1074',
  C_1075 = 'C_1075',
  C_1079 = 'C_1079',
  C_1080 = 'C_1080',

  C_1101 = 'C_1101',
  C_1102 = 'C_1102',
  C_1103 = 'C_1103',
  C_1104 = 'C_1104',

  C_1200 = 'C_1200',

  C_131 = 'C_131',
  C_1311 = 'C_1311',
  C_1312 = 'C_1312',
  C_1313 = 'C_1313',
  C_139 = 'C_139',
  C_1391 = 'C_1391',
  C_1392 = 'C_1392',
  C_1393 = 'C_1393',
  C_1394 = 'C_1394',
  C_1399 = 'C_1399',

  C_1410 = 'C_1410',
  C_1420 = 'C_1420',
  C_1430 = 'C_1430',

  C_151 = 'C_151',
  C_1511 = 'C_1511',
  C_1512 = 'C_1512',
  C_1520 = 'C_1520',

  C_1610 = 'C_1610',
  C_162 = 'C_162',
  C_1621 = 'C_1621',
  C_1622 = 'C_1622',
  C_1623 = 'C_1623',
  C_1629 = 'C_1629',

  C_1701 = 'C_1701',
  C_1702 = 'C_1702',
  C_1709 = 'C_1709',

  C_181 = 'C_181',
  C_1811 = 'C_1811',
  C_1812 = 'C_1812',
  C_1820 = 'C_1820',

  C_1910 = 'C_1910',
  C_1920 = 'C_1920',

  C_201 = 'C_201',
  C_2011 = 'C_2011',
  C_2012 = 'C_2012',
  C_2013 = 'C_2013',
  C_202 = 'C_202',
  C_2021 = 'C_2021',
  C_2022 = 'C_2022',
  C_2023 = 'C_2023',
  C_2029 = 'C_2029',
  C_2030 = 'C_2030',

  C_2100 = 'C_2100',

  C_221 = 'C_221',
  C_2211 = 'C_2211',
  C_2219 = 'C_2219',
  C_2220 = 'C_2220',

  C_2310 = 'C_2310',
  C_239 = 'C_239',
  C_2391 = 'C_2391',
  C_2392 = 'C_2392',
  C_2393 = 'C_2393',
  C_2394 = 'C_2394',
  C_2395 = 'C_2395',
  C_2396 = 'C_2396',
  C_2399 = 'C_2399',

  C_2410 = 'C_2410',
  C_2420 = 'C_2420',
  C_243 = 'C_243',
  C_2431 = 'C_2431',
  C_2432 = 'C_2432',

  C_251 = 'C_251',
  C_2511 = 'C_2511',
  C_2512 = 'C_2512',
  C_2513 = 'C_2513',
  C_2520 = 'C_2520',
  C_259 = 'C_259',
  C_2591 = 'C_2591',
  C_2592 = 'C_2592',
  C_2593 = 'C_2593',
  C_2599 = 'C_2599',

  C_2610 = 'C_2610',
  C_2620 = 'C_2620',
  C_2630 = 'C_2630',
  C_2640 = 'C_2640',
  C_265 = 'C_265',
  C_2651 = 'C_2651',
  C_2652 = 'C_2652',
  C_2660 = 'C_2660',
  C_2670 = 'C_2670',
  C_2680 = 'C_2680',

  C_2710 = 'C_2710',
  C_2720 = 'C_2720',
  C_273 = 'C_273',
  C_2731 = 'C_2731',
  C_2732 = 'C_2732',
  C_2733 = 'C_2733',
  C_2740 = 'C_2740',
  C_2750 = 'C_2750',
  C_2790 = 'C_2790',

  C_281 = 'C_281',
  C_2811 = 'C_2811',
  C_2812 = 'C_2812',
  C_2813 = 'C_2813',
  C_2814 = 'C_2814',
  C_2815 = 'C_2815',
  C_2816 = 'C_2816',
  C_2817 = 'C_2817',
  C_2818 = 'C_2818',
  C_2819 = 'C_2819',
  C_282 = 'C_282',
  C_2821 = 'C_2821',
  C_2822 = 'C_2822',
  C_2823 = 'C_2823',
  C_2824 = 'C_2824',
  C_2825 = 'C_2825',
  C_2826 = 'C_2826',
  C_2829 = 'C_2829',

  C_2910 = 'C_2910',
  C_2920 = 'C_2920',
  C_2930 = 'C_2930',

  C_301 = 'C_301',
  C_3011 = 'C_3011',
  C_3012 = 'C_3012',
  C_3020 = 'C_3020',
  C_3030 = 'C_3030',
  C_3040 = 'C_3040',
  C_309 = 'C_309',
  C_3091 = 'C_3091',
  C_3092 = 'C_3092',
  C_3099 = 'C_3099',

  C_3100 = 'C_3100',

  C_321 = 'C_321',
  C_3211 = 'C_3211',
  C_3212 = 'C_3212',
  C_3220 = 'C_3220',
  C_3230 = 'C_3230',
  C_3240 = 'C_3240',
  C_3250 = 'C_3250',
  C_3290 = 'C_3290',

  C_331 = 'C_331',
  C_3311 = 'C_3311',
  C_3312 = 'C_3312',
  C_3313 = 'C_3313',
  C_3314 = 'C_3314',
  C_3315 = 'C_3315',
  C_3319 = 'C_3319',
  C_3320 = 'C_3320',

  D_3510 = 'D_3510',
  D_3520 = 'D_3520',
  D_3530 = 'D_3530',

  E_3600 = 'E_3600',

  E_3700 = 'E_3700',

  E_381 = 'E_381',
  E_3811 = 'E_3811',
  E_3812 = 'E_3812',
  E_382 = 'E_382',
  E_3821 = 'E_3821',
  E_3822 = 'E_3822',
  E_3830 = 'E_3830',

  E_3900 = 'E_3900',

  F_4100 = 'F_4100',

  F_4210 = 'F_4210',
  F_4220 = 'F_4220',
  F_4290 = 'F_4290',

  F_431 = 'F_431',
  F_4311 = 'F_4311',
  F_4312 = 'F_4312',
  F_432 = 'F_432',
  F_4321 = 'F_4321',
  F_4322 = 'F_4322',
  F_4329 = 'F_4329',
  F_4330 = 'F_4330',
  F_4390 = 'F_4390',

  G_4510 = 'G_4510',
  G_4520 = 'G_4520',
  G_4530 = 'G_4530',
  G_4540 = 'G_4540',

  G_4610 = 'G_4610',
  G_4620 = 'G_4620',
  G_4630 = 'G_4630',
  G_464 = 'G_464',
  G_4641 = 'G_4641',
  G_4649 = 'G_4649',
  G_465 = 'G_465',
  G_4651 = 'G_4651',
  G_4652 = 'G_4652',
  G_4653 = 'G_4653',
  G_4659 = 'G_4659',
  G_466 = 'G_466',
  G_4661 = 'G_4661',
  G_4662 = 'G_4662',
  G_4663 = 'G_4663',
  G_4669 = 'G_4669',
  G_4690 = 'G_4690',

  G_471 = 'G_471',
  G_4711 = 'G_4711',
  G_4719 = 'G_4719',
  G_472 = 'G_472',
  G_4721 = 'G_4721',
  G_4722 = 'G_4722',
  G_4723 = 'G_4723',
  G_4730 = 'G_4730',
  G_474 = 'G_474',
  G_4741 = 'G_4741',
  G_4742 = 'G_4742',
  G_475 = 'G_475',
  G_4751 = 'G_4751',
  G_4752 = 'G_4752',
  G_4753 = 'G_4753',
  G_4759 = 'G_4759',
  G_476 = 'G_476',
  G_4761 = 'G_4761',
  G_4762 = 'G_4762',
  G_4763 = 'G_4763',
  G_4764 = 'G_4764',
  G_477 = 'G_477',
  G_4771 = 'G_4771',
  G_4772 = 'G_4772',
  G_4773 = 'G_4773',
  G_4774 = 'G_4774',
  G_478 = 'G_478',
  G_4781 = 'G_4781',
  G_4782 = 'G_4782',
  G_4789 = 'G_4789',
  G_479 = 'G_479',
  G_4791 = 'G_4791',
  G_4799 = 'G_4799',

  H_491 = 'H_491',
  H_4911 = 'H_4911',
  H_4912 = 'H_4912',
  H_492 = 'H_492',
  H_4921 = 'H_4921',
  H_4922 = 'H_4922',
  H_4923 = 'H_4923',
  H_4930 = 'H_4930',

  H_501 = 'H_501',
  H_5011 = 'H_5011',
  H_5012 = 'H_5012',
  H_502 = 'H_502',
  H_5021 = 'H_5021',
  H_5022 = 'H_5022',

  H_5110 = 'H_5110',
  H_5120 = 'H_5120',

  H_5210 = 'H_5210',
  H_522 = 'H_522',
  H_5221 = 'H_5221',
  H_5222 = 'H_5222',
  H_5223 = 'H_5223',
  H_5224 = 'H_5224',
  H_5229 = 'H_5229',

  H_5310 = 'H_5310',
  H_5320 = 'H_5320',

  I_5510 = 'I_5510',
  I_5520 = 'I_5520',
  I_5590 = 'I_5590',

  I_5610 = 'I_5610',
  I_562 = 'I_562',
  I_5621 = 'I_5621',
  I_5629 = 'I_5629',
  I_5630 = 'I_5630',

  J_581 = 'J_581',
  J_5811 = 'J_5811',
  J_5812 = 'J_5812',
  J_5813 = 'J_5813',
  J_5819 = 'J_5819',
  J_5820 = 'J_5820',

  J_591 = 'J_591',
  J_5911 = 'J_5911',
  J_5912 = 'J_5912',
  J_5913 = 'J_5913',
  J_5914 = 'J_5914',
  J_5920 = 'J_5920',

  J_6010 = 'J_6010',
  J_6020 = 'J_6020',

  J_6110 = 'J_6110',
  J_6120 = 'J_6120',
  J_6130 = 'J_6130',
  J_6190 = 'J_6190',

  J_6201 = 'J_6201',
  J_6202 = 'J_6202',
  J_6209 = 'J_6209',

  J_631 = 'J_631',
  J_6311 = 'J_6311',
  J_6312 = 'J_6312',
  J_639 = 'J_639',
  J_6391 = 'J_6391',
  J_6399 = 'J_6399',

  K_641 = 'K_641',
  K_6411 = 'K_6411',
  K_6419 = 'K_6419',
  K_6420 = 'K_6420',
  K_6430 = 'K_6430',
  K_649 = 'K_649',
  K_6491 = 'K_6491',
  K_6492 = 'K_6492',
  K_6499 = 'K_6499',

  K_651 = 'K_651',
  K_6511 = 'K_6511',
  K_6512 = 'K_6512',
  K_6520 = 'K_6520',
  K_6530 = 'K_6530',

  K_661 = 'K_661',
  K_6611 = 'K_6611',
  K_6612 = 'K_6612',
  K_6619 = 'K_6619',
  K_662 = 'K_662',
  K_6621 = 'K_6621',
  K_6622 = 'K_6622',
  K_6629 = 'K_6629',
  K_6630 = 'K_6630',

  L_6810 = 'L_6810',
  L_6820 = 'L_6820',

  M_6910 = 'M_6910',
  M_6920 = 'M_6920',

  M_7010 = 'M_7010',
  M_7020 = 'M_7020',

  M_7110 = 'M_7110',
  M_7120 = 'M_7120',

  M_7210 = 'M_7210',
  M_7220 = 'M_7220',

  M_7310 = 'M_7310',
  M_7320 = 'M_7320',

  M_7410 = 'M_7410',
  M_7420 = 'M_7420',
  M_7490 = 'M_7490',

  M_7500 = 'M_7500',

  N_7710 = 'N_7710',
  N_772 = 'N_772',
  N_7721 = 'N_7721',
  N_7722 = 'N_7722',
  N_7729 = 'N_7729',
  N_7730 = 'N_7730',
  N_7740 = 'N_7740',

  N_7810 = 'N_7810',
  N_7820 = 'N_7820',
  N_7830 = 'N_7830',

  N_791 = 'N_791',
  N_7911 = 'N_7911',
  N_7912 = 'N_7912',
  N_7990 = 'N_7990',

  N_8010 = 'N_8010',
  N_8020 = 'N_8020',
  N_8030 = 'N_8030',

  N_8110 = 'N_8110',
  N_812 = 'N_812',
  N_8121 = 'N_8121',
  N_8129 = 'N_8129',
  N_8130 = 'N_8130',

  N_821 = 'N_821',
  N_8211 = 'N_8211',
  N_8219 = 'N_8219',
  N_8220 = 'N_8220',
  N_8230 = 'N_8230',
  N_829 = 'N_829',
  N_8291 = 'N_8291',
  N_8292 = 'N_8292',
  N_8299 = 'N_8299',

  O_841 = 'O_841',
  O_8411 = 'O_8411',
  O_8412 = 'O_8412',
  O_8413 = 'O_8413',
  O_842 = 'O_842',
  O_8421 = 'O_8421',
  O_8422 = 'O_8422',
  O_8423 = 'O_8423',
  O_8430 = 'O_8430',

  P_8510 = 'P_8510',
  P_852 = 'P_852',
  P_8521 = 'P_8521',
  P_8522 = 'P_8522',
  P_8530 = 'P_8530',
  P_854 = 'P_854',
  P_8541 = 'P_8541',
  P_8542 = 'P_8542',
  P_8549 = 'P_8549',
  P_8550 = 'P_8550',

  Q_8610 = 'Q_8610',
  Q_8620 = 'Q_8620',
  Q_8690 = 'Q_8690',

  Q_8710 = 'Q_8710',
  Q_8720 = 'Q_8720',
  Q_8730 = 'Q_8730',
  Q_8790 = 'Q_8790',

  Q_8810 = 'Q_8810',
  Q_8890 = 'Q_8890',

  R_9000 = 'R_9000',

  R_9101 = 'R_9101',
  R_9102 = 'R_9102',
  R_9103 = 'R_9103',

  R_9200 = 'R_9200',

  R_931 = 'R_931',
  R_9311 = 'R_9311',
  R_9312 = 'R_9312',
  R_9319 = 'R_9319',
  R_932 = 'R_932',
  R_9321 = 'R_9321',
  R_9329 = 'R_9329',

  S_941 = 'S_941',
  S_9411 = 'S_9411',
  S_9412 = 'S_9412',
  S_9420 = 'S_9420',
  S_949 = 'S_949',
  S_9491 = 'S_9491',
  S_9492 = 'S_9492',
  S_9499 = 'S_9499',

  S_951 = 'S_951',
  S_9511 = 'S_9511',
  S_9512 = 'S_9512',
  S_952 = 'S_952',
  S_9521 = 'S_9521',
  S_9522 = 'S_9522',
  S_9523 = 'S_9523',
  S_9524 = 'S_9524',
  S_9529 = 'S_9529',

  S_9601 = 'S_9601',
  S_9602 = 'S_9602',
  S_9603 = 'S_9603',
  S_9609 = 'S_9609',

  T_9700 = 'T_9700',

  T_9810 = 'T_9810',
  T_9820 = 'T_9820',

  U_9900 = 'U_9900',

  Z_9999 = 'Z_9999',

  Z_10011 = 'Z_10011',
  Z_10012 = 'Z_10012',
  Z_10013 = 'Z_10013',
  Z_10014 = 'Z_10014',
  Z_10015 = 'Z_10015',
  Z_10021 = 'Z_10021',
  Z_10022 = 'Z_10022',
  Z_10023 = 'Z_10023',
  Z_10024 = 'Z_10024',
  Z_10025 = 'Z_10025',

  Z_10110 = 'Z_10110',
  Z_10111 = 'Z_10111',
  Z_10112 = 'Z_10112',
  Z_10113 = 'Z_10113',
  Z_10114 = 'Z_10114',
  Z_10115 = 'Z_10115',
  Z_10116 = 'Z_10116',
  Z_10117 = 'Z_10117',
  Z_10118 = 'Z_10118',

  Z_101100 = 'Z_101100',
  Z_101101 = 'Z_101101',
  Z_101102 = 'Z_101102',
  Z_101103 = 'Z_101103',

  Z_101200 = 'Z_101200',
  Z_101201 = 'Z_101201',
  Z_101202 = 'Z_101202',
  Z_101203 = 'Z_101203',
  Z_101204 = 'Z_101204',
  Z_101205 = 'Z_101205',
  Z_101206 = 'Z_101206',
  Z_101207 = 'Z_101207',
  Z_101208 = 'Z_101208',
  Z_101209 = 'Z_101209',
  Z_101210 = 'Z_101210',
  Z_101211 = 'Z_101211',
  Z_101212 = 'Z_101212',
  Z_101213 = 'Z_101213',
  Z_101214 = 'Z_101214',
  Z_101215 = 'Z_101215',
  Z_101216 = 'Z_101216',
  Z_101217 = 'Z_101217',
  Z_101218 = 'Z_101218',
  Z_101219 = 'Z_101219',
  Z_101220 = 'Z_101220',
  Z_101221 = 'Z_101221',

  Z_101300 = 'Z_101300',
  Z_101301 = 'Z_101301',
  Z_101302 = 'Z_101302',
  Z_101303 = 'Z_101303',
  Z_101304 = 'Z_101304',
  Z_101305 = 'Z_101305',
  Z_101306 = 'Z_101306',
  Z_101307 = 'Z_101307',
  Z_101308 = 'Z_101308',
  Z_101309 = 'Z_101309',

  Z_101400 = 'Z_101400',
  Z_101401 = 'Z_101401',
  Z_101402 = 'Z_101402',

  Z_101900 = 'Z_101900',

  Z_10210 = 'Z_10210',
  Z_10211 = 'Z_10211',
  Z_10220 = 'Z_10220',
  Z_10230 = 'Z_10230',
  Z_10240 = 'Z_10240',
  Z_10250 = 'Z_10250',
  Z_10260 = 'Z_10260',
  Z_10270 = 'Z_10270',
  Z_10271 = 'Z_10271',
  Z_10272 = 'Z_10272',
  Z_10280 = 'Z_10280',
  Z_10299 = 'Z_10299',

  Z_10310 = 'Z_10310',
  Z_10320 = 'Z_10320',
  Z_10330 = 'Z_10330',
  Z_10340 = 'Z_10340',
  Z_10350 = 'Z_10350',

  Z_10400 = 'Z_10400',
}
